
//Libraries
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
  name: "UserStatus",
  setup() {
    //Data

    const isLoading = ref<boolean>(true);

    //Methods

    const getData = () => {
      setTimeout(() => {
        isLoading.value = false;
      }, 600);
    };

    //Lifecycle Hooks

    onMounted(() => {
      getData();
    });

    return {
      //Data
      isLoading,
    };
  },
});
